<template>
  <div>
    <div
      v-for="(invoice, invoiceIndex) in invoiceItems"
      :id="`${notSubmittedState && parseInt(invoice.validated, 10) === 0 ? 'card-expense-' + invoice.id : ''}`"
      :key="invoice.id"
      class="card-expense"
    >
      <div class="wrapper">
        <div class="resume">
          <div v-if="!forApprove && !forApproved" class="first-col">
            <b-form-checkbox
              v-if="+invoice.amountTotal !== 0 && (!forPending || invoice.subType === INVOICE_SUBTYPE.ELEC_INVOICE_TO_RECEIVE)"
              v-model="toSubmitList"
              size="lg"
              :value="invoice"
              @change="$emit('select', $event)"
            />
          </div>
          <div class="second-col" :style="`width: ${notSubmittedState && parseInt(invoice.validated, 10) === 0 ? '56.5%;' : '67.5%;'}`">
            <div class="description">
              {{ invoice.description }}
            </div>
            <div class="title">#{{ invoice.id }}</div>
            <div class="amount">{{ rendCurrency(invoice.amountTotal) }}</div>
            <div class="date">
              {{ dateToLiteral(invoice.date) }}
            </div>
          </div>
          <div class="third-col">
            <div class="status-wrapper flex flex-col justify-content-between">
              <div class="wrap-status d-flex">
                <div v-if="invoice.allExpenseItemIsInContract === false" class="d-flex justify-content-start align-items-center">
                  <button v-b-tooltip.left.html class="btn-transparent text-color-rhapsody-in-blue" :title="tooltipInvoiceOutsideContract()">
                    <component :is="getLucideIcon('AlertTriangle')" color="#EA4E" :size="18" />
                  </button>
                </div>
                <div :class="`status ${invoice.statusClass ? invoice.statusClass : getStatusClass(parseInt(invoice.validated, 10))}`">
                  {{ invoice.validatedStatus ? invoice.validatedStatus : getValidatedText(parseInt(invoice.validated, 10)) }}
                </div>
              </div>
              <div class="w-auto wrap-status d-flex justify-content-center">
                <div class="status" :class="provideSubTypeClass(invoice.subType)" style="font-size: 0.6rem">
                  {{ provideSubTypeText(invoice.subType, 1, 2, 3) }}
                </div>
              </div>
              <div class="type">
                <span class="icon">
                  <component :is="getLucideIcon('FileText')" color="#5B6164D6" :size="14" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="actions">
          <div v-if="notSubmittedState && invoice.images" class="first-col" @click="showPicture(invoice.images, invoice)">
            <div class="icon">
              <component :is="getLucideIcon('FileImage')" color="#06263E" :size="16" />
            </div>
            <div class="label" style="margin-top: 1px">{{ FormMSG(28, 'See Receipt') }}</div>
          </div>
          <div class="second-col" :style="`width: '100%`">
            <div v-if="notSubmittedState" class="cursor-pointer d-flex flex-row" @click="$emit('show-detail', invoice, invoiceIndex)">
              <div class="icon">
                <component :is="getLucideIcon('Edit')" color="#06263E" :size="16" />
              </div>
              <div class="label">{{ FormMSG(29, 'Edit') }}</div>
            </div>
            <div v-if="submittedState" class="cursor-pointer d-flex flex-row" @click="$emit('show-detail', invoice, invoiceIndex)">
              <div class="icon">
                <component :is="getLucideIcon('Eye')" color="#06263E" :size="16" />
              </div>
              <div class="label">{{ FormMSG(33, 'View') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// props
import mapProps from '@/shared/vuePropsMapper';
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';
// helpers & utils
import { rendCurrency } from '~helpers';
import moment from 'moment';
// constants
import { FINANCES, INVOICE_SUBTYPE } from '@/shared/constants';

export default {
  name: 'InvoicesDataViewMobile',
  mixins: [languageMessages, globalMixin, invoicesToolsMixin],
  props: {
    ...mapProps(['forApprove', 'forDraft', 'forPending', 'forApproved', 'forMultipleInvoice'], {
      type: Boolean,
      default: false
    }),
    notSubmittedState: Boolean,
    submittedState: Boolean,
    invoiceItems: {
      type: Array,
      default: () => []
    },
    notSubmittedInvoices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      toSubmitList: [],
      INVOICE_SUBTYPE,
      rendCurrency
    };
  },
  watch: {
    notSubmittedInvoices: {
      handler(newVal) {
        this.toSubmitList = newVal;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    dateToLiteral(invoiceDate) {
      const langCurrent = this.currentLang;
      const fullLiteralDate = moment(invoiceDate).locale(`${langCurrent}`).format(`dddd, Do MMMM YYYY`);

      return fullLiteralDate;
    }
  }
};
</script>

<style lang="scss" scoped></style>
